import type { Module } from '../types/groupModulePermissions';

export const mockModules: Module[] = [
  {
    id: 'issue-occ',
    name: 'Issue OCC',
    category: 'Core',
    isCore: true,
    permissions: {
      create: true,
      read: true,
      update: true,
      delete: false
    }
  },
  {
    id: 'occ-retrieval',
    name: 'OCC Retrieval',
    category: 'Core',
    isCore: true,
    permissions: {
      create: true,
      read: true,
      update: true,
      delete: false
    }
  },
  {
    id: 'cancelation',
    name: 'Cancelation',
    category: 'Financial',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: false,
      delete: true
    }
  },
  {
    id: 'cancelled-occ',
    name: 'Cancelled OCC',
    category: 'Financial',
    isCore: false,
    permissions: {
      create: false,
      read: true,
      update: false,
      delete: false
    }
  },
  {
    id: 'payment',
    name: 'Payment',
    category: 'Financial',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: true,
      delete: false
    }
  },
  {
    id: 'activate-frontliner',
    name: 'Activate Frontliner',
    category: 'User Management',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: false,
      delete: false
    }
  },
  {
    id: 'deactivate-frontliner',
    name: 'Deactivate Frontliner',
    category: 'User Management',
    isCore: false,
    permissions: {
      create: false,
      read: true,
      update: true,
      delete: true
    }
  },
  {
    id: 'forex',
    name: 'Forex',
    category: 'Financial',
    isCore: false,
    permissions: {
      create: false,
      read: true,
      update: false,
      delete: false
    }
  },
  {
    id: 'hbs-upload',
    name: 'HBS Upload',
    category: 'Data Management',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: false,
      delete: false
    }
  },
  {
    id: 'plan-download',
    name: 'Plan Download',
    category: 'Planning',
    isCore: false,
    permissions: {
      create: false,
      read: true,
      update: false,
      delete: false
    }
  },
  {
    id: 'plan-upload',
    name: 'Plan Upload',
    category: 'Planning',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: true,
      delete: false
    }
  },
  {
    id: 'account-executive',
    name: 'Account Executive',
    category: 'Agency',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: true,
      delete: true
    }
  },
  {
    id: 'travel-agency',
    name: 'Travel Agency',
    category: 'Agency',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: true,
      delete: false
    }
  },
  {
    id: 'user-maintenance',
    name: 'User Maintenance',
    category: 'System',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: true,
      delete: true
    }
  },
  {
    id: 'group-maintenance',
    name: 'Group Maintenance',
    category: 'System',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: true,
      delete: false
    }
  },
  {
    id: 'itinerary',
    name: 'Itinerary',
    category: 'Planning',
    isCore: false,
    permissions: {
      create: true,
      read: true,
      update: true,
      delete: false
    }
  },
  {
    id: 'tax-rate',
    name: 'Tax Rate',
    category: 'Financial',
    isCore: false,
    permissions: {
      create: false,
      read: true,
      update: true,
      delete: false
    }
  },
  {
    id: 'user-guide',
    name: 'User Guide',
    category: 'Core',
    isCore: true,
    permissions: {
      create: false,
      read: true,
      update: false,
      delete: false
    }
  }
];